var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCryingFace = function SvgIconCryingFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 102 102"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Icon_crying_face_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Icon_crying_face_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C499",
    fillOpacity: 0.5,
    d: "M50.755 96.896c25.482 0 46.14-20.658 46.14-46.14 0-25.484-20.657-46.142-46.14-46.142-25.484 0-46.142 20.658-46.142 46.141s20.658 46.141 46.142 46.141"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Icon_crying_face_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_crying_face_svg__d)",
    d: "M50.755 96.896c25.482 0 46.14-20.658 46.14-46.14 0-25.484-20.657-46.142-46.14-46.142-25.484 0-46.142 20.658-46.142 46.141s20.658 46.141 46.142 46.141"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#Icon_crying_face_svg__e)",
    strokeWidth: 0.461,
    d: "M50.755 4.844c25.355 0 45.91 20.556 45.91 45.912s-20.555 45.91-45.91 45.91c-25.356 0-45.911-20.555-45.911-45.91 0-25.356 20.555-45.912 45.91-45.912Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0D4056",
    d: "M79.21 67.674H60.754c0-2.128 4.136-3.845 9.228-3.845 5.093 0 9.228 1.717 9.228 3.845M40.757 67.674H22.301c0-2.128 4.135-3.845 9.228-3.845s9.228 1.717 9.228 3.845",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#16121E",
    strokeLinecap: "round",
    strokeWidth: 2.307,
    d: "m62.29 80.824-.293-.22a18.716 18.716 0 0 0-22.778.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16121E",
    d: "M75.08 54.412c.182.542.284 1.122.284 1.726v4.614a5.384 5.384 0 1 1-10.766 0v-4.614a5.38 5.38 0 0 1 3.735-5.125zM33.17 51.012a5.385 5.385 0 0 1 3.741 5.127v4.614a5.383 5.383 0 0 1-10.766 0v-4.614c0-.606.101-1.188.286-1.732z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.209,
    cy: 63.675,
    r: 1.846,
    fill: "#C7F3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.299,
    cy: 63.675,
    r: 1.846,
    fill: "#C7F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7F3FF",
    d: "M77.055 75.54c0 1.092-.827 1.977-1.846 1.977s-1.846-.885-1.846-1.977.827-3.56 1.846-3.56 1.846 2.468 1.846 3.56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_crying_face_svg__b",
    width: 103.355,
    height: 103.356,
    x: -0.924,
    y: -0.923,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_11309_9489",
    stdDeviation: 2.768
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_crying_face_svg__c",
    width: 95.972,
    height: 95.974,
    x: 2.768,
    y: 4.614,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.846
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.923
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11309_9489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_11309_9489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Icon_crying_face_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 92.2824 -99.5113 0 50.755 4.614)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_crying_face_svg__e",
    x1: 50.755,
    x2: 50.755,
    y1: 4.614,
    y2: 96.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Icon_crying_face_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h101.511v101.511H0z"
  })))));
};
export default SvgIconCryingFace;